module.exports = __webpack_public_path__ + "img/logo-oderon-bw-40.888d2727.png";